@if (isLoading) {
  <div class="flex items-center justify-center full-height">
    <p-progressSpinner />
  </div>
} @else {
  <div>
    <p class="mb-4">Select where the fax should be moved.</p>
    <p class="mb-2">Move to:</p>
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-2">
        @if (showFaxFolder) {
          <div class="flex items-start">
            <p-radio-button
              name="selectedDestination"
              value="FaxFolder"
              [(ngModel)]="selectedDestination"
              (ngModelChange)="selectDestination()"
              inputId="destination1"
            />
            <label for="destination1" class="ml-2">Fax Folder</label>
          </div>
        }

        <div class="flex items-center">
          @if (showFaxFolder) {
            <p-radio-button
              name="selectedDestination"
              value="Inbox"
              [(ngModel)]="selectedDestination"
              (ngModelChange)="selectDestination()"
              inputId="destination2"
            />
          }
          <label for="destination2" class="ml-2">Different Fax Inbox</label>
        </div>
      </div>
    </div>

    <div class="flex flex-col mt-4">
      <label for="selectedLocation" class="field-required mb-1">Location:</label>

      @if (selectedDestination === FaxDestination.Inbox) {
        <p-select
          [filter]="true"
          filterBy="label"
          [showClear]="true"
          [options]="inboxOptions"
          [(ngModel)]="selectedLocation"
          [disabled]="!!faxData.row.memberId"
          styleClass="w-full"
          appendTo="body"
          optionLabel="label"
          placeholder="Select"
        />
      }

      @if (selectedDestination === FaxDestination.FaxFolder) {
        <p-select
          [filter]="true"
          filterBy="label"
          [showClear]="true"
          [options]="folderOptions"
          [(ngModel)]="selectedLocation"
          [disabled]="!faxData.row.memberId"
          styleClass="w-full"
          appendTo="body"
          optionLabel="label"
          placeholder="Select"
        />
      }

      @if (!!message) {
        <p
          class="mt-1 p-1 flex flex-row items-start gap-1 rounded-sm max-w-max"
          [ngClass]="message.warning ? 'bg-yellow-100' : 'bg-gray-100'"
        >
          <i
            class="pi ml-1 p-1"
            [ngClass]=" message.warning ? 'pi-exclamation-triangle' : 'pi-info-circle'"
          ></i>
          <span class="text-xs">{{ message.text }}</span>
        </p>
      }
    </div>

    <div class="flex flex-row gap-2 justify-end items-center my-2">
      @if (isSubmitClicked) {
        <p-progressSpinner ariaLabel="loading" styleClass="p-progress-spinner-sm" />
      }

      <button
        aria-label="Cancel"
        class="p-button-secondary"
        pButton
        type="button"
        (click)="cancelClick()"
      >
        Cancel
      </button>

      @if (!isSubmitClicked) {
        <button
          pButton
          type="button"
          (click)="submitClick()"
          [disabled]="
            (selectedDestination === FaxDestination.Inbox &&
              !!faxData.row.memberId) ||
            (selectedDestination === FaxDestination.FaxFolder &&
              !faxData.row.memberId) ||
            !selectedLocation
          "
        >
          Move Fax
        </button>
      }
    </div>
  </div>
}
